<template>
  <b-modal
    :id="modalId"
    ref="modalChatPaziente"
    size="xl"
    hide-footer
    header-class="border-bottom-0 pb-0"
    body-class="pt-0 px-3 pb-3"
    @shown="onModalShown"
    @hidden="onModalHidden"
    centered
  >
    <template #modal-title>
      <div class="d-flex align-items-center">
        <b-icon
          icon="chat-dots-fill"
          class="text-primary mr-2"
          font-scale="1.2"
          aria-hidden="true"
        ></b-icon>
        <span class="font-weight-bold">{{ titolo }}</span>
      </div>
    </template>

    <patient-chat-section
      v-if="isOpen"
      ref="chatSection"
      :patientHashid="hashidPaziente"
      :patientFullName="nomePaziente"
      :initialChannelHashid="initialChannelHashid"
      :hideHeader="true"
      :hideChannelList="hideChannelList"
      :companyScope="companyScope"
      @messages-read="$emit('messages-read')"
      @archive-updated="$emit('archive-updated')"
    />
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import PatientChatSection from "@/app/modules/servizi/profiloSanitario/components/PatientChatSection.vue";

export default {
  name: "ModalChatPaziente",
  components: {
    PatientChatSection,
  },
  props: {
    // Piu' modali della stessa specie possono convivere nella stessa pagina
    modalId: {
      type: String,
      default: "modal-chat-paziente",
    },
    // Senza hashid vale l'utente loggato: e' il caso del cittadino
    patientHashid: {
      type: String,
      default: "",
    },
    patientFullName: {
      type: String,
      default: "",
    },
    initialChannelHashid: {
      type: String,
      default: "",
    },
    hideChannelList: {
      type: Boolean,
      default: false,
    },
    companyScope: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    ...mapState("utente", ["user"]),
    isCitizen() {
      return Number(this.user && this.user.type) === 0;
    },
    hashidPaziente() {
      if (this.patientHashid) return this.patientHashid;
      // Il ripiego sull'utente loggato vale per il cittadino, che di se stesso e'
      // il paziente. Per l'operatore che apre la chat dal menu significherebbe
      // filtrare i canali su se stesso, cioe' non trovarne nessuno: senza hashid
      // la sezione elenca le proprie conversazioni, che e' quello che serve.
      if (!this.isCitizen) return "";
      return this.user && this.user.hashid ? this.user.hashid : "";
    },
    nomePaziente() {
      if (this.patientFullName) return this.patientFullName;
      if (!this.user) return this.$t("ModalChatPaziente.paziente");
      const name = this.user.anagrafica?.name || this.user.name || "";
      const surname = this.user.anagrafica?.surname || this.user.surname || "";
      return (
        `${name} ${surname}`.trim() ||
        this.user.email ||
        this.$t("ModalChatPaziente.paziente")
      );
    },
    titolo() {
      if (this.isCitizen && !this.patientHashid) {
        return this.$t("ModalChatPaziente.titolo_cittadino");
      }
      // Operatore senza un paziente scelto: la modale mostra tutte le sue
      // conversazioni, quindi il titolo non puo' nominarne una
      if (!this.patientHashid) {
        return this.$t("ModalChatPaziente.titolo_operatore_proprie");
      }
      return this.$t("ModalChatPaziente.titolo_con_paziente", {
        nome: this.nomePaziente,
      });
    },
  },
  methods: {
    onModalShown() {
      this.isOpen = true;
      this.$nextTick(() => {
        if (this.$refs.chatSection) {
          this.$refs.chatSection.loadChannels(this.initialChannelHashid);
        }
      });
    },
    onModalHidden() {
      this.isOpen = false;
      this.$emit("hidden");
    },
  },
};
</script>
